import React, {Component} from 'react';

const gitInfo = require('../../static/gitInfo.txt')


export default class GitInfo extends Component {

  state = {gitBranch: ''};

  componentDidMount () {
      fetch(gitInfo)
      .then(result => result.text())
      .then(data => {
        this.setState({gitBranch: data})
      })
    }

  render() {
    return(<span style={{fontSize:'10px'}}>{this.state.gitBranch}</span>)
  }
}



// WEBPACK FOOTER //
// ./src/components/GitInfo/GitInfo.js